// assets/js/common-nav.js
// document.addEventListener('DOMContentLoaded', () => {
//   const navMain = document.querySelector('.section-nav-main');
//   const navButtonContainer = document.querySelector('.section-nav-button');
//   const buttons = document.querySelectorAll('.section-nav-button .nav-button');

//     const anchorMap = Array.from(buttons)
//         .map((btn) => {
//         const href = btn.getAttribute('href');
//         if (!href || href === '#') return null;
//         const target = document.querySelector(href);
//         return target ? { btn, target } : null;
//         })
//         .filter(Boolean);

//   if (anchorMap.length === 0) return;

//   // 点击处理
//   buttons.forEach((button) => {
//     button.addEventListener('click', (e) => {
//       e.preventDefault();
//       const href = button.getAttribute('href');
//       const target = document.querySelector(href);
//       if (!target) return;

//       buttons.forEach((btn) => btn.classList.remove('active'));
//       button.classList.add('active');

//       target.scrollIntoView({
//         behavior: 'smooth',
//         block: 'start'
//       });
//     });
//   });

//   let isUserScrollingFromClick = false;

//   const observerOptions = {
//     root: null,
//     rootMargin: '-35% 0px -65% 0px',
//     threshold: 0
//   };

//   const observers = new Map();

//   anchorMap.forEach(({ btn, target }) => {
//     const observer = new IntersectionObserver((entries) => {
//       if (isUserScrollingFromClick) return;
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           buttons.forEach((b) => b.classList.remove('active'));
//           btn.classList.add('active');
//         }
//       });
//     }, observerOptions);

//     observer.observe(target);
//     observers.set(target, observer);
//   });

//   buttons.forEach((button) => {
//     button.addEventListener('click', () => {
//       isUserScrollingFromClick = true;
//       setTimeout(() => {
//         isUserScrollingFromClick = false;
//       }, 1400);
//     });
//   });

//   // 初始 active
//   if (anchorMap.length > 0) {
//     buttons.forEach((btn) => btn.classList.remove('active'));
//     anchorMap[0].btn.classList.add('active');
//   }
// });

// assets/js/common-nav.js
// document.addEventListener('DOMContentLoaded', () => {
//   const navMain = document.querySelector('.section-nav-main');
//   const navButtonContainer = document.querySelector('.section-nav-button .nav-container > div');
//   const buttons = document.querySelectorAll('.section-nav-button .nav-button');
//   const mobileMediaQuery = window.matchMedia('(max-width: 768px)');

//   const getScrollableContainer = (button) => {
//     if (!button) return navButtonContainer;

//     const directContainer = button.closest('.nav-container')?.querySelector(':scope > div');
//     if (directContainer && directContainer.scrollWidth > directContainer.clientWidth) {
//       return directContainer;
//     }

//     let parent = button.parentElement;
//     while (parent) {
//       if (parent.scrollWidth > parent.clientWidth) return parent;
//       parent = parent.parentElement;
//     }
//     return navButtonContainer;
//   };

//   const centerButtonInView = (button) => {
//     if (!button || !mobileMediaQuery.matches) return;
//     const scrollContainer = getScrollableContainer(button);
//     if (!scrollContainer) return;

//     const containerRect = scrollContainer.getBoundingClientRect();
//     const buttonRect = button.getBoundingClientRect();
//     const deltaToCenter =
//       (buttonRect.left - containerRect.left) -
//       (containerRect.width / 2 - buttonRect.width / 2);
//     const targetScrollLeft = scrollContainer.scrollLeft + deltaToCenter;
//     const maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
//     const clampedScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

//     scrollContainer.scrollTo({
//       left: clampedScrollLeft,
//       behavior: 'smooth'
//     });
//   };

//   const setActiveButton = (activeButton) => {
//     buttons.forEach((btn) => btn.classList.remove('active'));
//     activeButton.classList.add('active');
//     centerButtonInView(activeButton);
//   };

//   const anchorMap = Array.from(buttons)
//     .map((btn) => {
//       const href = btn.getAttribute('href');
//       if (!href || href === '#') return null;
//       const target = document.querySelector(href);
//       return target ? { btn, target } : null;
//     })
//     .filter(Boolean);

//   if (anchorMap.length === 0) return;

//   // click handling
//   buttons.forEach((button) => {
//     button.addEventListener('click', (e) => {
//       e.preventDefault();
//       const href = button.getAttribute('href');
//       const target = document.querySelector(href);
//       if (!target) return;

//       setActiveButton(button);

//       target.scrollIntoView({
//         behavior: 'smooth',
//         block: 'start'
//       });
//     });
//   });

//   let isUserScrollingFromClick = false;

//   const observerOptions = {
//     root: null,
//     rootMargin: '-35% 0px -65% 0px',
//     threshold: 0
//   };

//   const observers = new Map();

//   anchorMap.forEach(({ btn, target }) => {
//     const observer = new IntersectionObserver((entries) => {
//       if (isUserScrollingFromClick) return;
//       entries.forEach((entry) => {
//         if (entry.isIntersecting) {
//           setActiveButton(btn);
//         }
//       });
//     }, observerOptions);

//     observer.observe(target);
//     observers.set(target, observer);
//   });

//   buttons.forEach((button) => {
//     button.addEventListener('click', () => {
//       isUserScrollingFromClick = true;
//       setTimeout(() => {
//         isUserScrollingFromClick = false;
//       }, 1400);
//     });
//   });

//   // initial active
//   if (anchorMap.length > 0) {
//     setActiveButton(anchorMap[0].btn);
//   }
// });

// assets/js/common-nav.js
document.addEventListener('DOMContentLoaded', () => {
  const navMain = document.querySelector('.section-nav-main');
  const navButtonContainer = document.querySelector('.section-nav-button');
  const buttons = document.querySelectorAll('.section-nav-button .nav-button');
  const navScrollContainer = navButtonContainer ? navButtonContainer.querySelector('.nav-container > div') : null;

  const isElementVisible = (element) => {
    if (!element) return false;
    const styles = window.getComputedStyle(element);
    return styles.display !== 'none' && styles.visibility !== 'hidden' && element.getClientRects().length > 0;
  };

  const getTargetsByHref = (href) => {
    if (!href || href === '#' || !href.startsWith('#')) return [];

    const anchorName = href.slice(1);
    const targets = [];
    const primaryTarget = document.querySelector(href);

    if (primaryTarget) targets.push(primaryTarget);

    document.querySelectorAll(`[data-nav-anchor="${anchorName}"]`).forEach((target) => {
      if (!targets.includes(target)) targets.push(target);
    });

    return targets;
  };

  const ensureButtonVisible = (button) => {
    if (!button || !navScrollContainer) return;

    const buttonRect = button.getBoundingClientRect();
    const containerRect = navScrollContainer.getBoundingClientRect();
    const leftOverflow = buttonRect.left - containerRect.left;
    const rightOverflow = buttonRect.right - containerRect.right;

    if (leftOverflow < 0) {
      navScrollContainer.scrollBy({
        left: leftOverflow - 16,
        behavior: 'smooth'
      });
      return;
    }

    if (rightOverflow > 0) {
      navScrollContainer.scrollBy({
        left: rightOverflow + 16,
        behavior: 'smooth'
      });
    }
  };

  const setActiveButton = (button) => {
    if (!button) return;
    buttons.forEach((btn) => btn.classList.remove('active'));
    button.classList.add('active');
    ensureButtonVisible(button);
  };

  const anchorMap = Array.from(buttons)
    .map((btn) => {
      const href = btn.getAttribute('href');
      const targets = getTargetsByHref(href);
      return targets.length ? { btn, targets } : null;
    })
    .filter(Boolean);

  if (anchorMap.length === 0) return;

  let isUserScrollingFromClick = false;

  const observerOptions = {
    root: null,
    rootMargin: '-35% 0px -65% 0px',
    threshold: 0
  };

  const observers = new Map();

  anchorMap.forEach(({ btn, targets }) => {
    targets.forEach((target) => {
      const observer = new IntersectionObserver((entries) => {
        if (isUserScrollingFromClick) return;

        entries.forEach((entry) => {
          if (entry.isIntersecting && isElementVisible(entry.target)) {
            setActiveButton(btn);
          }
        });
      }, observerOptions);

      observer.observe(target);
      observers.set(target, observer);
    });
  });

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      setActiveButton(button);
      isUserScrollingFromClick = true;
      setTimeout(() => {
        isUserScrollingFromClick = false;
      }, 1400);
    });
  });

  if (anchorMap.length > 0) {
    setActiveButton(anchorMap[0].btn);
  }
});
